// modules
import { createAction } from 'redux-actions'
import { dispatch } from '../../setup/redux'

export const SET_IS_OPEN = 'SET_IS_OPEN'
export const setIsOpen = createAction(SET_IS_OPEN, value => ({ value }))
export const dispatchSetIsOpen = (...args) => dispatch(setIsOpen(...args))

export const TOGGLE_IS_OPEN = 'TOGGLE_IS_OPEN'
export const toggleIsOpen = createAction(TOGGLE_IS_OPEN)
export const dispatchToggleIsOpen = () => dispatch(toggleIsOpen())
